var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 9a5 5 0 1 1-10 0 5 5 0 0 1 10 0M16.057 19.5c4.622 0 8.443 3.875 8.443 8.5h3c0-6.255-5.137-11.5-11.443-11.5h-.114C9.637 16.5 4.5 21.745 4.5 28h3c0-4.625 3.821-8.5 8.443-8.5z"
  })));
};
export default SvgUser;